// services/socketService.js
import { io } from "socket.io-client";
import { API } from "../shared/api/Api";

export const initializeSocket = (token) => {
  const socket = io(API.nestapi, {
    extraHeaders: {
      Authorization: `Bearer ${token}`,
    },
    transports: ["polling"],
    autoConnect: false // Manual connection control
  });

  socket.on("connect", () => {
    console.log("Socket connected:", socket.connected);
  });

  socket.on("connect_error", (err) => {
    console.error("Socket connection error:", err);
  });

  socket.on("disconnect", (reason) => {
    console.log("Socket disconnected:", reason);
  });

  return socket;
};
